import React, { createContext, useContext, useState } from "react";

const BoletinContext = createContext();

export function useBoletin() {
  return useContext(BoletinContext);
}

export function BoletinProvider({ children }) {
  const [noticias, setNoticias] = useState([]);
  const [recomendaciones, setRecomendaciones] = useState([]);
  const [noticiaDestacada, setNoticiaDestacada] = useState(null);
  const [totalNoticias, setTotalNoticias] = useState(0);
  const [cargando, setCargando] = useState(true);

  return (
    <BoletinContext.Provider
      value={{
        noticias,
        setNoticias,
        recomendaciones,
        setRecomendaciones,
        noticiaDestacada,
        setNoticiaDestacada,
        totalNoticias,
        setTotalNoticias,
        cargando,
        setCargando,
      }}
    >
      {children}
    </BoletinContext.Provider>
  );
}
